import { gallery } from "@/mocks/gossipData";
import Reveal from "./Reveal";

export default function CoverGallery() {
  return (
    <section id="gallery" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-primary-500" />
                一张图比十句话直观
              </p>
              <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-foreground-950 md:text-[28px]">
                新料图鉴 · 封面抢先看
              </h2>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                同框图、旧图对比、波形标注，跟着封面一眼读懂这条新瓜的争议点在哪。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 gap-4 md:gap-5 lg:grid-cols-4">
          {gallery.map((g, i) => (
            <Reveal key={g.caption} delay={i * 60} className={g.ratio === "tall" ? "row-span-2" : ""}>
              <a href="#gallery" className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <div
                  className={`relative w-full overflow-hidden ${
                    g.ratio === "tall" ? "aspect-[3/4]" : "aspect-[16/10]"
                  }`}
                >
                  <img
                    src={g.cover}
                    alt={`${g.caption}封面图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent" />
                  <span className="absolute left-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-black/35 text-background-50 backdrop-blur-sm">
                    <i className="ri-camera-line text-sm" />
                  </span>
                  <div className="absolute inset-x-0 bottom-0 p-3">
                    <p className="text-sm font-bold text-white">{g.caption}</p>
                    <p className="mt-0.5 line-clamp-2 text-[11px] leading-snug text-white/85">{g.note}</p>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}